<template>
  <v-card
    :class="getBannerStyle(error)"
    class="vCardGeneral elevation-0 clearfix mt-2 p-1 pt-2 pb-2"
  >
    <div class="errBoxIcon">
      <v-img
        aria-hidden="true"
        max-height="36"
        contain
        :src="getBannerIcon(error)"
        :class="getBannerIconStyle(error)"
      ></v-img>
    </div>
    <v-flex column>
      <v-flex row justify-space-between>
        <h3 :class="getBannerTextStyle(error)">{{ error.title }}</h3>
        <div v-if="$getConst('VALIDATION_SEVERITY_TYPE', 'WARNING') === error.severityType">
          <span
            v-if="!error.isDismissed" :class="error.isDismissed ? 'greyBannerTextTrend' : 'bannerTextTrend'"
          >➢ Click “X” to right of warning to hide the warning message.</span>
        </div>
        <div v-if="$getConst('VALIDATION_SEVERITY_TYPE', 'ERROR') === error.severityType">
          <span
            class="bannerTextError"
          >➢ Errors must be corrected before the survey can be submitted.</span>
        </div>
      </v-flex>
      <v-flex row>
        <p :class="getBannerTextStyle(error)">
          {{ error.message }}
          <v-btn
            v-if="error.message.includes('dismissed')"
            class="primary white--text"
            text
            small
            @click="showAllWarnings"
          >Show Warnings</v-btn>
        </p>
      </v-flex>

      <!-- <div>
          <p style="margin-top:10px;color:black;font-weight:bold;">Please enter an explanation.</p>
          <v-textarea outline value no-resize rows="1"></v-textarea>
      </div>-->
    </v-flex>
    <!-- <div style="float:left;width:10%;">
            <div class="clearfix buttons-container">
                <v-btn class="button" rounded style="color: white;background-color: red !important;margin: 24px 0;" @click="onCloseError">Close</v-btn>
            </div>
    </div>-->
  </v-card>
</template>

<script>
import { CONSTANTS } from "@/common/constants.js";

/**
 * The question validation message banner.
 */
export default {
  name: "WesError",
  props: {
    // index is the question id
    index: Number,
    error: Object
  },
  methods: {
    onCloseError: function (evt) {
      this.$emit("closeError", { index: this.index });
    },
    showAllWarnings: function () {
      this.$emit("show", { index: this.index });
    },
    getBannerStyle (error) {
      let bannerStyle = "";
      let errorIsWarningAndBannerAndAllWarningsDismissed = error.isDismissed;
      if (error.severityType === CONSTANTS.VALIDATION_SEVERITY_TYPE.ERROR) {
        bannerStyle = "bannerVCardError";
      } else if (errorIsWarningAndBannerAndAllWarningsDismissed) {
        bannerStyle = "bannerVCardTrendDismissed";
      } else {
        bannerStyle = "bannerVCardTrend";
      }
      return bannerStyle;
    },
    getBannerTextStyle (error) {
      let bannerTextStyle = "";
      let errorIsWarningAndBannerAndAllWarningsDismissed = error.isDismissed;
      if (error.severityType === CONSTANTS.VALIDATION_SEVERITY_TYPE.ERROR) {
        bannerTextStyle = "bannerTextError";
      } else if (errorIsWarningAndBannerAndAllWarningsDismissed) {
        bannerTextStyle = "bannerTextTrendDismissed";
      } else {
        bannerTextStyle = "bannerTextTrend";
      }
      return bannerTextStyle;
    },
    getBannerIcon (error) {
      let bannerIcon = "";
      let errorIsWarningAndBannerAndAllWarningsDismissed = error.isDismissed;
      if (error.severityType === CONSTANTS.VALIDATION_SEVERITY_TYPE.ERROR) {
        bannerIcon = require("@/assets/error-64.png");
      } else if (errorIsWarningAndBannerAndAllWarningsDismissed) {
        // TODO Add dismissed warning icon
        bannerIcon = require("@/assets/warning-64.png");
      } else {
        bannerIcon = require("@/assets/warning-64.png");
      }
      return bannerIcon;
    },
    getBannerIconStyle (error) {
      let bannerIconStyle = "";
      if (error.isDismissed) {
        // TODO Add dismissed warning icon
        bannerIconStyle = "greyImage";
      }
      return bannerIconStyle;
    }
  }
};
</script>

<style scoped>
div.vCardGeneral {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid gray; /* default colors */
  background-color: lightgray;
}

div.vCardGeneral p {
  margin: 0;
}

div.bannerVCardError {
  border-color: #A00B0B; /* match text color */
  background-color: #ffe7e7;
}
.bannerTextError {
  color: #A00B0B;
}

div.bannerVCardTrend {
  border-color: #604800; /* match text color */
  background-color: #ffe699;
}
.bannerTextTrend {
  color: #604800;
}

div.bannerVCardTrendDismissed {
  border-color: gray;
  background-color: #e6e6e6;
}
.bannerTextTrendDismissed {
  color: #212121;
}

h3 {
  font-size: 14pt;
  font-weight: bold;
  margin: 0 0 5px 0;
}

div.errBoxIcon {
  align-self: flex-start;
}

.greyBannerTextTrend {
  /* color: #212121; */
  display: none;
}

.greyImage {
  filter: grayscale(100%);
}
</style>
